import React, { useEffect } from 'react';
import * as NotiStack from 'notistack';
import { SnackbarProvider } from 'material-ui-snackbar-provider';
import { createTheme, ThemeProvider } from '@mui/material';
import {
  createMuiTheme,
  ThemeProvider as LegacyThemeProvider,
} from '@material-ui/core/styles';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { BrowserRouter } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
// import * as Sentry from '@sentry/react';

import MainRouter from './MainRouter';
import { MergedDownloadProvider } from './components/modules/VideoFileList/DownloadDataModal/MergedDownloadProvider';
import './App.scss';
import { SESSION_EXPIRED_SNACKBAR_KEY } from './api/axios';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xxl: true;
  }
}

const fontFamily = '"Gilroy", sans-serif';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#39b3ea',
      dark: '#2899cc',
      contrastText: '#010c1c',
    },
    secondary: {
      main: '#6500aa',
    },
    background: {
      default: '#030711',
      paper: '#0a1929',
    },
    text: {
      primary: '#fafafa',
      secondary: '#a1a1aa',
    },
    divider: 'rgba(255, 255, 255, 0.1)',
  },
  typography: {
    fontFamily,
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      xxl: 1800,
    },
  },
});

const legacyTheme = createMuiTheme({
  typography: {
    fontFamily,
  },
  shape: {
    borderRadius: 10,
  },
});

const App: React.FC = () => {
  useEffect(() => {
    try {
      const val = localStorage.getItem(SESSION_EXPIRED_SNACKBAR_KEY);
      if (val === '1') {
        localStorage.removeItem(SESSION_EXPIRED_SNACKBAR_KEY);
        NotiStack.enqueueSnackbar('Your session has expired. Please log in again', {
          variant: 'warning',
          autoHideDuration: 15000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      }
    } catch {}
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <LegacyThemeProvider theme={legacyTheme}>
          <ThemeProvider theme={theme}>
            <NotiStack.SnackbarProvider
              maxSnack={8}
              action={(snackbarId) => <button onClick={() => NotiStack.closeSnackbar(snackbarId)}>Dismiss</button>}
            >
              <SnackbarProvider SnackbarProps={{ autoHideDuration: 8000 }}>
                <DndProvider backend={HTML5Backend}>
                  <MergedDownloadProvider>
                    <MainRouter />
                  </MergedDownloadProvider>
                </DndProvider>
              </SnackbarProvider>
            </NotiStack.SnackbarProvider>
          </ThemeProvider>
        </LegacyThemeProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
// export default Sentry.withProfiler(App);
